import React, { forwardRef, useImperativeHandle, useState } from 'react'

import s from './styles.module.scss'

import ForgotPassword from './forgot-password/forgot-password'
import {
  ForgotPasswordInterface,
  LoginInterface,
  LoginSiteNavigator,
  ResetPasswordInterface,
  SubscribeInterface,
} from './login.types'
import LoginForm from './login-form/login-form'
import { LoginLangSelector } from './login-lang-selector'
import LoginSiteTab from './login-site-tab/login-site-tab'
import ResetPasswordForm from './reset-password/reset-password-form'
import SubscribeForm from './subscribe-form/subscribe-form'
import { Image } from '../../../components/atoms/containers'

const LoginTemplate = forwardRef(
  (
    {
      loginSiteNavigator,
      forgotPasswordOptions,
      loginOptions,
      subscribeOptions,
      resetPasswordOptions,
    }: {
      loginSiteNavigator?: LoginSiteNavigator
      forgotPasswordOptions: ForgotPasswordInterface
      loginOptions: LoginInterface
      subscribeOptions?: SubscribeInterface
      resetPasswordOptions?: ResetPasswordInterface
    },
    ref,
  ) => {
    const [showForgotPassword, setShowForgotPassword] = useState<boolean>(false)
    const [showSubscribe, setShowSubscribe] = useState<boolean>(
      subscribeOptions?.showSubscribe || false,
    )

    useImperativeHandle(ref, () => ({ setShowSubscribe }))

    const [showResetPassword, setShowResetPassword] = useState<boolean>(
      resetPasswordOptions?.showResetPassword || false,
    )
    return (
      <div className={s.container}>
        <div className={s.illustration}></div>
        <div className={s.content}>
          <div className={s.logo}>
            <Image src='/images/logo-naboo.svg' alt='' type='contain' />
          </div>

          <LoginSiteTab loginSiteNavigator={loginSiteNavigator} />

          <div className={`relative ${s.card}`}>
            <div className='absolute right-[30px] top-[30px]'>
              <LoginLangSelector />
            </div>
            {showResetPassword && resetPasswordOptions && (
              <ResetPasswordForm
                {...resetPasswordOptions}
                setShowResetPassword={setShowResetPassword}
              />
            )}

            {showSubscribe && subscribeOptions && (
              <SubscribeForm
                {...subscribeOptions}
                setShowSubscribe={setShowSubscribe}
              />
            )}

            {showForgotPassword && (
              <ForgotPassword
                {...forgotPasswordOptions}
                setShowForgotPassword={setShowForgotPassword}
              />
            )}

            {!showForgotPassword && !showResetPassword && !showSubscribe && (
              <LoginForm
                {...loginOptions}
                setShowForgotPassword={setShowForgotPassword}
              />
            )}
          </div>
        </div>
      </div>
    )
  },
)

export default LoginTemplate
